import type { FormField } from '@lucid/lego';

export const createCaseFormFields: FormField[] = [
  {
    id: 'overviewGroup',
    fieldType: 'group',
    title: 'Overview',
    width: 'full',
    children: [
      {
        id: 'priority',
        fieldType: 'dropdown',
        name: 'priority',
        apiKey: 'priority',
        label: 'Priority',
        placeholder: 'Select One',
        selectedOption: 'standard',
        required: true,
        width: 'full',
        options: [
          { label: 'Standard', value: 'STANDARD' },
          { label: 'Urgent', value: 'URGENT' },
        ],
        validationMessages: {
          required: 'This is required',
        },
      },
    ],
  },
  {
    id: 'detailsGroup',
    fieldType: 'group',
    title: 'Details',
    width: 'full',
    children: [
      {
        id: 'caseSubject',
        fieldType: 'textarea',
        name: 'caseSubject',
        apiKey: 'caseSubject',
        label: 'Case Title',
        placeholder: 'Brief description of the issue',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'caseSummary',
        fieldType: 'textarea',
        name: 'caseSummary',
        apiKey: 'caseSummary',
        label: 'Case Summary',
        placeholder: 'Case Summary',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'requestedSupport',
        fieldType: 'textarea',
        name: 'requestedSupport',
        apiKey: 'requestedSupport',
        label: 'Request Support',
        placeholder: 'Request Support needed from Lucid',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
    ],
  },
  {
    id: 'attachmentsGroup',
    fieldType: 'group',
    title: 'Attachments',
    width: 'full',
    children: [
      {
        id: 'attachements',
        fieldType: 'text',
        type: 'file',
        name: 'attachements',
        apiKey: 'attachements',
        helperText: 'File upload (PDF, JPG, PNG, LOG, ≤10 MB each)',
        placeholder: 'Drag and drop files here, or click to browse',
        required: false,
        allowMultipleFiles: true,
      },
    ],
  },
  {
    id: 'formButtons',
    fieldType: 'buttonGroup',
    buttons: [
      {
        id: 'save',
        label: 'Save',
        color: 'neutral',
        size: 'medium',
        type: 'secondary',
        position: 'left',
      },
      {
        id: 'submit',
        label: 'Create Case',
        color: 'neutral',
        size: 'medium',
        type: 'primary',
        position: 'right',
      },
    ],
  },
];

// Form fields for Tech Support - Non Service (VIN Related)
export const techSupportFormFields: FormField[] = [
  {
    id: 'overviewGroup',
    fieldType: 'group',
    title: 'Overview',
    width: 'full',
    children: [
      {
        id: 'priority',
        fieldType: 'dropdown',
        name: 'priority',
        apiKey: 'priority',
        label: 'Priority',
        placeholder: 'Select One',
        selectedOption: 'STANDARD',
        required: true,
        width: 'half',
        options: [
          { label: 'STANDARD', value: 'STANDARD' },
          { label: 'URGENT', value: 'URGENT' },
          { label: 'ESCALATED', value: 'ESCALATED' },
        ],
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'dateStampOfEvent',
        fieldType: 'date_picker',
        name: 'dateStampOfEvent',
        apiKey: 'dateStampOfEvent',
        label: 'Date Stamp of the Event',
        required: true,
        width: 'half',
        size: 'medium',
        validationMessages: {
          required: 'Date is required',
        },
      },
      {
        id: 'locationOfEvent',
        fieldType: 'text',
        name: 'locationOfEvent',
        apiKey: 'locationOfEvent',
        label: 'Location of Event',
        placeholder: 'Enter location of event',
        required: false,
        width: 'full',
      },
    ],
  },
  {
    id: 'detailsGroup',
    fieldType: 'group',
    title: 'Details',
    width: 'full',
    children: [
      {
        id: 'caseSubject',
        fieldType: 'textarea',
        name: 'caseSubject',
        apiKey: 'caseSubject',
        label: 'Case Title',
        placeholder: 'Brief description of the issue',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'caseSummary',
        fieldType: 'textarea',
        name: 'caseSummary',
        apiKey: 'caseSummary',
        label: 'Case Summary',
        placeholder: 'Case Summary',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'requestedSupport',
        fieldType: 'textarea',
        name: 'requestedSupport',
        apiKey: 'requestedSupport',
        label: 'Request Support',
        placeholder: 'Request Support needed from Lucid',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
    ],
  },
  {
    id: 'attachmentsGroup',
    fieldType: 'group',
    title: 'Attachments',
    width: 'full',
    children: [
      {
        id: 'attachements',
        fieldType: 'text',
        type: 'file',
        name: 'attachements',
        apiKey: 'attachements',
        helperText: 'File upload (PDF, JPG, PNG, LOG, ≤10 MB each)',
        placeholder: 'Drag and drop files here, or click to browse',
        required: false,
        allowMultipleFiles: true,
      },
    ],
  },
  {
    id: 'formButtons',
    fieldType: 'buttonGroup',
    buttons: [
      {
        id: 'save',
        label: 'Save',
        color: 'neutral',
        size: 'medium',
        type: 'secondary',
        position: 'left',
      },
      {
        id: 'submit',
        label: 'Create Case',
        color: 'neutral',
        size: 'medium',
        type: 'primary',
        position: 'right',
      },
    ],
  },
];

// Form fields for Escalation (VIN Related)
export const escalationFormFields: FormField[] = [
  {
    id: 'overviewGroup',
    fieldType: 'group',
    title: 'Overview',
    width: 'full',
    children: [
      {
        id: 'priority',
        fieldType: 'dropdown',
        name: 'priority',
        apiKey: 'priority',
        label: 'Priority',
        placeholder: 'Select One',
        selectedOption: 'STANDARD',
        required: true,
        width: 'half',
        options: [
          { label: 'STANDARD', value: 'STANDARD' },
          { label: 'URGENT', value: 'URGENT' },
          { label: 'ESCALATED', value: 'ESCALATED' },
        ],
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'dateStampOfEvent',
        fieldType: 'date_picker',
        name: 'dateStampOfEvent',
        apiKey: 'dateStampOfEvent',
        label: 'Date Stamp of the Event',
        required: true,
        width: 'half',
        size: 'medium',
        validationMessages: {
          required: 'Date is required',
        },
      },
      {
        id: 'escalationType',
        fieldType: 'dropdown',
        name: 'escalationType',
        apiKey: 'escalationType',
        label: 'Escalation Type',
        placeholder: 'Select Escalation Type',
        required: true,
        width: 'full',
        options: [
          { label: 'Legal', value: 'legal' },
          { label: 'Compliant', value: 'compliant' },
          { label: 'Goodwill', value: 'goodwill' },
          { label: 'Other', value: 'other' },
        ],
        validationMessages: {
          required: 'Escalation type is required',
        },
      },
    ],
  },
  {
    id: 'detailsGroup',
    fieldType: 'group',
    title: 'Details',
    width: 'full',
    children: [
      {
        id: 'caseSubject',
        fieldType: 'textarea',
        name: 'caseSubject',
        apiKey: 'caseSubject',
        label: 'Case Title',
        placeholder: 'Brief description of the issue',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'caseSummary',
        fieldType: 'textarea',
        name: 'caseSummary',
        apiKey: 'caseSummary',
        label: 'Case Summary',
        placeholder: 'Case Summary',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
      {
        id: 'requestedSupport',
        fieldType: 'textarea',
        name: 'requestedSupport',
        apiKey: 'requestedSupport',
        label: 'Request Support',
        placeholder: 'Request Support needed from Lucid',
        required: true,
        validationMessages: {
          required: 'This is required',
        },
      },
    ],
  },
  {
    id: 'attachmentsGroup',
    fieldType: 'group',
    title: 'Attachments',
    width: 'full',
    children: [
      {
        id: 'attachements',
        fieldType: 'text',
        type: 'file',
        name: 'attachements',
        apiKey: 'attachements',
        helperText: 'File upload (PDF, JPG, PNG, LOG, ≤10 MB each)',
        placeholder: 'Drag and drop files here, or click to browse',
        required: false,
        allowMultipleFiles: true,
      },
    ],
  },
  {
    id: 'formButtons',
    fieldType: 'buttonGroup',
    buttons: [
      {
        id: 'save',
        label: 'Save',
        color: 'neutral',
        size: 'medium',
        type: 'secondary',
        position: 'left',
      },
      {
        id: 'submit',
        label: 'Create Case',
        color: 'neutral',
        size: 'medium',
        type: 'primary',
        position: 'right',
      },
    ],
  },
];
